/* 布局 */
//前台
import Layout from "@views/layout";

const goodsspecRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodsspec/list",
        name: "GOODSSPEC",
        meta: {
            title: "商品规格管理",
            keepAlive:true
        },
        component: () => import("@views/business/goodsspec/index.vue"),
    },
        ],
};

export default goodsspecRouter;
